import React, { useState, useEffect } from "react";
import theme from "../../../styles/theme";

const DropdownSimple = ({ label, options = [], value, onChange, placeholder = "Sélectionner...", disabled = false,style = {},onOpen, onClose, }) => {
  const [open, setOpen] = useState(false);
  // ✅ Notifie la carte quand la liste est ouverte ou fermée
  
  useEffect(() => {
    if (open && onOpen) onOpen();
    if (!open && onClose) onClose();
  }, [open]); // <-- déclenché à chaque changement d’état

  const handleSelect = (optionValue) => {
    if (disabled) return;
    onChange(optionValue);
    setOpen(false);
  };

  return (
    <div style={{ marginBottom: 0, position: "relative", display: "flex", alignItems: "center",...style, }}>
      {label && (
        <label style={{ display: "block", marginBottom: theme.spacing.xs }}>
          {label}
        </label>
      )}

      <div
        style={{
          border: `1px solid ${theme.colors.borders.default}`,
          borderRadius: style.borderRadius || theme.borders.radius.md, // ← permet d’override
          padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
          width: "100%", // largeur par défaut
          backgroundColor: disabled
            ? theme.colors.states.disabled
            : theme.colors.background.input,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        onClick={() => !disabled && setOpen(!open)}
      >
        {options.find((o) => o.value === value)?.label || placeholder}
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            maxHeight: "200px",
            overflowY: "auto",
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.sm,
            backgroundColor: theme.colors.background.surface,
            zIndex: 9999,
            marginTop: 2,
          }}
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => handleSelect(opt.value)}
              style={{
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                backgroundColor: value === opt.value ? theme.colors.background.muted : "transparent",
                color: theme.colors.text.default,
                transition: "background-color 0.2s",
                position: "relative",
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownSimple;
